import { render, staticRenderFns } from "./index.vue?vue&type=template&id=29234bee"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29234bee')) {
      api.createRecord('29234bee', component.options)
    } else {
      api.reload('29234bee', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=29234bee", function () {
      api.rerender('29234bee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Screenfull/index.vue"
export default component.exports